module.exports = __webpack_public_path__ + "media/images/diy/testimonial_chan-1f5acaedfcd7f7d8237942019aff8c31.jpg";